import axios from 'axios';
import FileSaver from 'file-saver';
import BackendClient from '../backend-client';
import Ticket, { modelFactory } from './model';
import { formatFilter } from './filters';

export default class TicketClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  async create(element, type, data, resolve, queryParams) {
    try {
      console.log('queryParams--------------------', queryParams);
      const response = await this.request('post', 'create')({
        element,
        type,
        data,
        resolve,
        queryParams, // source channel -> ticket.zflujo_canal
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      });
      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  list = (start, size, filters = {}, sortparam, type, asc) => {
    const filtersF = formatFilter(filters);
    const sort = `${sortparam} ${asc === true ? 'asc' : 'desc'}`;
    if (type === 'R') {
      this.$path = 'cr';
    } else if (type === 'I') {
      this.$path = 'in';
    } else if (type === 'P') {
      this.$path = 'pr';
    }

    return this.req(JSON.stringify(filtersF), {
      start,
      size,
      sort,
    });
  }

  detail = (type, idTicket, filters = {}) => {
    const cancelToken = axios.CancelToken.source();

    const filtersF = Object.keys(filters).length > 0 ? formatFilter(filters) : undefined;
    // filtersF.$and.push(sendFilters);

    let path;
    switch (type) {
    case 'R':
      path = 'cr';
      break;
    case 'I':
      path = 'in';
      break;
    default:
      path = 'pr';
    }

    const req = this.request('get', idTicket)({
      BackEnd: 'detailTicket',
      WC: filtersF,
    }, {
      path,
      cancelToken: cancelToken.token,
    });

    req.cancel = () => {
      req.cancelled = true;
      cancelToken.cancel('Operation was cancelled by user interaction');
    };

    req.format = this.format.bind(this);

    return req;
  }

  claim = async (ticketId, claimType, text, isMobile = false, tagActivity) => {
    await this.request('post', `${ticketId}/claim`)({
      claimType, text, isMobile, tagActivity,
    });
  }

  saveComment = async (idTicket, comment = '', tagActivity) => {
    const response = await this.request('post', `${idTicket}/comment`)({ comment, tagActivity });
    return this.format(response);
  }

  acceptClosing = async (idTicket, { comment, ratingScore, ratingComment, tagActivity }) => { // eslint-disable-line
    const response = await this.request('post', `${idTicket}/accept-closing`)({ comment, ratingScore, ratingComment, tagActivity }); // eslint-disable-line
    return this.format(response);
  }

  savePhoneTicket = async ({ idTicket, phoneTicket }) => {
    const response = await this.request('put', `${idTicket}/savePhonetTicket`)({ phoneTicket });
    return this.format(response);
  }

  cancelTicket = async (idTicket, comment = '', tagActivity) => {
    const response = await this.request('post', `${idTicket}/cancel`)({ comment, tagActivity });
    return this.format(response);
  }

  upload = async (idTicket, { file, comment, refNum }) => {
    try {
      const formData = new FormData();
      formData.append('description', comment);
      formData.append('file', file);
      formData.append('refNum', refNum);

      const response = await this.request('post', `${idTicket}/upload`)(formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('upload response', response);

      return { ok: true };
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  uploadApp = async (idTicket, {
    file, comment, refNum, accessKey, token,
  }, path) => {
    try {
      const formData = new FormData();
      formData.append('description', comment);
      formData.append('file', file);
      formData.append('refNum', refNum);

      let fetchPath = '';
      if (path.includes('/servicioandaluzdesalud/mics')) {
        fetchPath = '/servicioandaluzdesalud/mics';
      } else if (path.includes('/mics')) {
        fetchPath = '/mics';
      }

      const response = await fetch(`${fetchPath}/proxy-rest/ticket/${idTicket}/upload`, {
        method: 'POST',
        body: formData,
        headers: {
          'x-accesskey': accessKey,
          'x-jwt-token': token,
        },
      });

      console.log('upload response', response);
      return { ok: true };
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  download = async (idTicket, idAttach, refNumber, nameFile) => {
    try {
      const response = await this.request('get', `download/${idTicket}/attach`)({ idAttach, refNumber }, {
        responseType: 'blob',
      });
      FileSaver.saveAs(response.data, nameFile);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  delete = async (idTicket, idAttach, refNumber) => {
    try {
      const response = await this.request('delete', `delete/${idTicket}/attach`)({ idAttach, refNumber });
      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  approveTicket = async (idTicket, comment, tagActivity) => {
    comment = `Confirmo que he revisado esta solicitud y autorizo su tramitación, asumiendo la responsabilidad de esta aprobación. Esta acción quedará registrada en el historial de la solicitud. Aceptado.\n${comment}`; // eslint-disable-line
    const response = await this.request('post', `${idTicket}/approve`)({ comment, tagActivity });
    return this.format(response);
  }

  rejectTicket = async (idTicket, comment, tagActivity) => {
    const response = await this.request('post', `${idTicket}/reject`)({ comment, tagActivity });
    return this.format(response);
  }

  resolveTicket = async (idTicket, comment, tagActivity) => {
    const response = await this.request('post', `${idTicket}/resolve`)({ comment, tagActivity });
    return this.format(response);
  }

  escalateTicket = async (idTicket, comment, escalateAssignee) => {
    console.log('escalateTicket', escalateAssignee);
    const response = await this.request('post', `${idTicket}/escalate`)({ comment, escalateAssignee });
    return this.format(response);
  }

  export = async (idTicket) => {
    const response = await this.request('get', `${idTicket}/export`)({}, {
      responseType: 'blob',
    });
    FileSaver.saveAs(response.data, `${idTicket}.pdf`);
    return true;
  }

  approveAll = async (tickets, comment) => {
    comment = `Confirmo que he revisado esta solicitud y autorizo su tramitación, asumiendo la responsabilidad de esta aprobación. Esta acción quedará registrada en el historial de la solicitud. Aceptado.\n${comment}`; // eslint-disable-line
    const response = await this.request('post', 'pending_approval_all/approve')({ tickets, comment });
    return this.format(response);
  }

  rejectAll = async (tickets, comment) => {
    const response = await this.request('post', 'pending_approval_all/reject')({ tickets, comment });
    return this.format(response);
  }

  transferActivity = async ({
    idTicket, idAssign, idNextAssign, commentTransfer, tagActivity,
  }) => {
    const response = await this.request('put', 'pending_approval_all/transfer')({
      idTicket, idAssign, idNextAssign, commentTransfer, tagActivity,
    });
    return response;
  }

  getUsersforTranfers = async (ticket) => {
    const { referenceNumber } = ticket;

    const response = await this.request('get', `pending_approval_all/transfer/${ referenceNumber }`)();
    return response;
  }

  clone = async (idTicket, elementId) => {
    const response = await this.request('get', `${idTicket}/clone`)({ elementId });
    return this.format(response);
  }

  sendPfirmas = (idTicket) => this.request('put', `${idTicket}/portafirmas`)();

  createActivity = async (data) => {
    const response = await this.request('post', 'createActivity')({ data });
    return response;
  };
}

export {
  Ticket,
};
